import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { CdkDropList } from '@angular/cdk/drag-drop';

import { Rectangle } from '../../../widget-grid/models/Rectangle.model';
import {
  Enclosure,
  IChangeWidgetPosition,
  IContextMenuGridAction,
  IContextMenuGridEvent, IWidget
} from '../../../prisma-xs/models/prisma-xs.model';
import { EnclosureGridComponent } from '../enclosure-grid/enclosure-grid.component';
import { RESIZE_DIRECTIONS } from '../../../widget-grid/Utils';
import { IArticle } from '../../../prisma-xs/models/article.model';
import { IUprightOnGrid } from '../../../prisma-xs/models/upright.model';
import { EnclosureBorderDirective } from '../../directives/enclosure-border.directive';
import { IHighlightConfigurationArea } from '../../../enclosure/models/grid.model';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    selector: 'app-prisma-xs-grid',
    templateUrl: './grid.component.html',
    styleUrls: ['./grid.component.scss'],
    standalone: false
})
export class GridComponent {
  @ViewChild('gridContainer', {static: true}) gridContainer: ElementRef;
  @ViewChild('enclosureGridComponent', {static: true}) enclosureGridComponent: EnclosureGridComponent;
  @ViewChild('configurationGrid') configurationGrid: ElementRef;
  @ViewChild(EnclosureBorderDirective) enclosureBorder: EnclosureBorderDirective;

  @Input() enclosure: Enclosure;
  @Input() arrayOfUprights: IUprightOnGrid[];
  @Input() allArticles: IArticle[];

  @Input() cols: number;
  @Input() showCovers: boolean;
  @Input() zoomLevel: number;
  @Input() rows: number;
  @Input() minRows: number;
  @Input() minFields: number;
  @Input() maxRows: number;
  @Input() enclosureResizeDirections: RESIZE_DIRECTIONS[];
  @Input() maxFields: number;
  @Input() enclosurePosition: IWidget;
  @Input() enclosureType: string;
  @Input() showGrid: boolean;
  @Input() articleCopied: IArticle;
  @Input() widgets: IArticle[];
  @Input() placedKits: IArticle[] = [];
  @Input() contextMenuActionType;
  @Input() availablePlacingGrabbingArticleOnGrid: boolean;
  @Input() isEditableProject: boolean;
  @Input() dropArea: IHighlightConfigurationArea;

  @Output() inputEvent = new EventEmitter<KeyboardEvent>();

  @Output() widgetChange = new EventEmitter();
  @Output() resizeEnclosureChange = new EventEmitter();
  @Output() enterGrid = new EventEmitter();
  @Output() gridLeave = new EventEmitter();
  @Output() changeWidgetPosition = new EventEmitter<IChangeWidgetPosition>();
  @Output() list = new EventEmitter<CdkDropList>();
  @Output() contextMenuData = new EventEmitter<IContextMenuGridEvent>();
  @Output() contextMenuActionData = new EventEmitter<IContextMenuGridAction>();
  @Output() selectWidget = new EventEmitter<IArticle>();
  @Output() deleteSelected = new EventEmitter<void>();

  emitGridList(event) {
    this.list.emit(event);
  }

  resetHighlights() {
    this.enclosureGridComponent.resetHighlights();
  }

  isAreaObstructed(rectangle: Rectangle, options) {
    return this.enclosureGridComponent.isAreaObstructed(rectangle, options);
  }

  resizeEnclosure(event) {
    this.resizeEnclosureChange.emit(event);
  }

  enterOnGrid() {
    this.enterGrid.emit();
  }

  leaveGrid() {
    this.gridLeave.emit();
  }

  onSelectWidget(article) {
    this.selectWidget.next(article);
  }

  onWidgetPositionChange(event) {
    this.changeWidgetPosition.emit(event);
  }

  contextMenu(event) {
    this.contextMenuData.emit(event);
  }

  contextMenuAction(action: IContextMenuGridAction) {
    this.contextMenuActionData.emit(action);
  }
}
